window.addEventListener('DOMContentLoaded', () => {
  let scrollPosition = 0;

  const modal = document.getElementById('modal-window');
  const modalWindowContent = document.querySelector('.modal-window__content');
  const body = document.body;
  const customList = document.querySelector('.product__info-list');

  // REQ-007 FR-026 defect: .product-text is sticky on desktop, which creates a
  // stacking context that traps the drawer's z-index below later sections in
  // Safari. Reparent the drawer to <body> so it stacks against the page root.
  if (modal) {
    body.appendChild(modal);
  }

  customList?.addEventListener('click', event => {
    const template = event.target.closest('.product__info-item')?.querySelector(`[data-template]`);
    if (!template) return;

    scrollPosition = window.scrollY || document.documentElement.scrollTop;
    toggleDrawer(true);

    modalWindowContent.innerHTML = template.innerHTML;
    modalWindowContent.classList.add('is-open');
    modalWindowContent.scrollTop = 0;

    const closeButton = modal.querySelector('.modal-close');
    closeButton.addEventListener('click', closeModal);
  });

  window.addEventListener('click', function (event) {
    if (event.target === modal) {
      closeModal();
    }
  });

  function toggleDrawer(isOpen) {
    if (isOpen) {
      body.classList.add('drawer-active');
      modal.style.display = 'flex';
    } else {
      modal.style.display = 'none';
      body.classList.remove('drawer-active');
    }
  }

  function closeModal() {
    document.querySelector('.modal-window').classList.add('close-modal-window');
    modalWindowContent.classList.add('is-close');

    setTimeout(() => {
      toggleDrawer(false);
      modalWindowContent.innerHTML = '';
      modalWindowContent.classList.remove('is-close');
      document.querySelector('.modal-window').classList.remove('close-modal-window');
      modalWindowContent.classList.remove('is-open');
    }, 500);

    window.scrollTo(0, scrollPosition);
  }
});
